module.exports = __webpack_public_path__ + "static/media/line-pattern.dc18ae4c.svg";